import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
@Injectable({
  providedIn: 'root'
})
export class StateService {
  licenseId: string;
  constructor(private cookieService: CookieService) {

  }
  public setLicenseId(licenseId: string) {
    this.licenseId = licenseId;
    this.cookieService.set("licenseId", licenseId);
  }
  public getLicenseId(): string {
    if (this.licenseId) {
      return this.licenseId;
    }
    var licenseId = this.cookieService.get("licenseId");
    licenseId = licenseId ? licenseId : "";
    return licenseId;
  }
}
